/*eslint-disable*/
import React         from 'react'
import { Button }    from 'antd'
import Dropzone      from 'react-dropzone'
import DragFilesIcon from '../../../assets/logo/dragfiles.png'
import './styles.scss'

export default ({on_select_files, on_select_folders, onDrop }) => (
    <Dropzone onDrop={onDrop} id='dropzone' className='local-empty-state center-child'>
      <img src={DragFilesIcon} />
      <span>Drag & Drop Files</span>

      {/* <span>or</span> */}

      <div>
        <Button ghost type="primary" onClick={(e)=> e.stopPropagation() || on_select_folders()}>
          <span>Select Folders</span>
        </Button>

        <Button  type="primary" onClick={(e)=> e.stopPropagation() || on_select_files()}>
          <span>Select Files</span>
        </Button>

      </div>
    </Dropzone>
)
